"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungType = void 0;
var VerpackungType;
(function (VerpackungType) {
    VerpackungType["palette"] = "palette";
    VerpackungType["trommel"] = "trommel";
    VerpackungType["karton"] = "karton";
})(VerpackungType = exports.VerpackungType || (exports.VerpackungType = {}));
//# sourceMappingURL=VerpackungModel.js.map